const METERS_TO_MILES = 0.000621371;

export function convertMetersToMiles(meters: number) {
  return meters * METERS_TO_MILES;
}

export function convertMilesToMeters(miles: number) {
  return (miles * 1) / METERS_TO_MILES;
}
